export const pmt = (rate: number, periods: number, loanAmount: number) =>
    (loanAmount * Math.pow(1 + rate, periods)) /
    (1 + rate * 0) /
    ((Math.pow(1 + rate, periods) - 1) / rate);
